<template>
    <div class="modal fade show d-block" tabindex="-1" role="dialog" >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('default.edit')}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$close()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">

            <v-wait for="edit">

                <loading slot="waiting"/>

                <form @submit.prevent="validate_edit">

                    <div class="form-group">
                      <div class="alert alert-danger" v-if="errorMsg">
                        <template v-for="error in errorMsg">
                          <li>{{ error }}</li>
                        </template>
                      </div>
                    </div>

                    <div class="form-group">

                        <label for="name">{{ $t('simple.name') }}</label>

                        <input
                            class="form-control"
                            type="text"
                            id="name"
                            name="name"
                            v-validate="'required'"
                            v-model="name"
                        >

                        <small v-show="errors.has('name')" class="form-text text-danger"><font-awesome-icon :icon="'times-circle'" /> {{ errors.first('name') }}</small>

                    </div>

                    <div v-if="integration === 'twitter' || integration === 'instagram' || integration === 'facebook' || integration === 'googleplay' || integration === 'linkedin' || integration === 'youtube'" class="form-group">

                        <label for="username">{{ $t('simple.username') }}</label>

                        <input 
                            class="form-control"
                            type="text"
                            id="username"
                            name="username"
                            v-validate="'required|excluded:'+ this.accounts.filter(o => o.integration_id == integration && o.id !== this.id).map(i => i.username.toLowerCase())"
                            v-model="username"
                            @input="username = $event.target.value.toLowerCase()"
                        >

                        <small v-show="errors.has('username')" class="form-text text-danger"><font-awesome-icon :icon="'times-circle'" /> {{ errors.first('username') }}</small>

                    </div>

                    <div v-else-if="integration === 'whatsapp'" class="form-group">

                        <label for="phone">{{ $t('simple.phone_number') }}</label>

                        <input
                            class="form-control"
                            type="number"
                            id="phone"
                            name="phone"
                            v-model="phone"
                            readonly
                        >

                    </div>

                    <div v-if="integration === 'sikayetvar'" class="form-group">

                        <label for="api_token">{{ $t('simple.api_token') }}</label>

                        <div class="input-group">
                            <input
                                v-if="!token_editing"
                                class="form-control"
                                type="text"
                                value="••••••••••••"
                                readonly
                            >
                            <input
                                v-else
                                class="form-control"
                                type="text"
                                id="api_token"
                                name="api_token"
                                v-validate="'required'"
                                v-model="api_token"
                            >
                            <div class="input-group-append" v-if="!token_editing">
                                <b-button variant="outline-secondary" type="button" @click="editToken()">{{ $t('default.edit') }}</b-button>
                            </div>
                        </div>

                        <small v-if="errors.has('api_token')" class="form-text text-danger"><font-awesome-icon :icon="'times-circle'" /> {{ errors.first('api_token') }}</small>
                        <small v-if="token_error" class="form-text text-danger"><font-awesome-icon :icon="'times-circle'" /> {{ token_error }}</small>

                    </div>

                    <div class="form-group">

                        <label for="confirmation" v-b-tooltip.hover :title="$t('confirmation.confirmation_process_desc')">{{ $t('confirmation.confirmation_process') }}:</label>

                        <b-form-checkbox v-model="confirmation" switch>
                            {{ check_confirmation() }}
                        </b-form-checkbox>


                    </div>

                </form>

            </v-wait>

          </div>

          <div class="modal-footer">

            <b-button @click="$close(false)" variant="secondary">{{ $t('simple.cancel') }}</b-button>
            <div v-b-tooltip.hover.right="{
                 title: !user_permissions.includes('update-accounts')? $t('permission.permission_denied', { permission: 'update-accounts' }) : '',customClass: 'tooltip-dark' }"
                 style="display: inline-block">
              <b-button  @click="validate_edit()" variant="primary" :class="!user_permissions.includes('update-accounts') ? 'cursor-not-allowed' : ''"
                         :disabled="!user_permissions.includes('update-accounts')">{{ $t('simple.save') }}</b-button>
            </div>
          </div>

        </div>
      </div>
    </div>
</template>
<script>

    import {mapGetters} from "vuex";

    export default {

        mounted: function () {
            // Component mounted
            console.log('Account Edit Modal mounted');

            // Get data to edit
            this.edit(this.id);
        },

        destroyed() {
            console.log('Account Edit Modal destroyed.');
        },

        data: function() {

             return  {

                accounts_api: '/api/v1/settings/accounts/',
                name: '',
                integration: '',
                username: '',
                phone: '',
                api_token: '',
                token_editing: false,
                token_error: '',
                errorMsg: null,
                confirmation: false,

            }

        },

        methods: {

            edit: async function(id) {

                // Loading start
                this.$wait.start('edit');

                // Account edit data
                await axios.get(this.accounts_api + id)
                    .then((response) => {

                        // Update modal data
                        this.name = response.data.name;
                        this.username = response.data.username;
                        this.phone = response.data.phone;
                        this.integration = response.data.integration_id;
                        this.confirmation = response.data.confirmation;

                        // Loading stop
                        this.$wait.end('edit');

                    })
                    .catch((error) => {

                        // Loading stop
                        this.$wait.end('edit');

                        // Show error
                        Vue.toasted.error(this.$t('simple.error_info'));
                    });

            },

            account_edit: async function(){

                // Loading start
                this.$wait.start('edit');

                let payload = {
                    name: this.name,
                    username: this.username,
                    confirmation: this.confirmation,
                };

                if (this.integration === 'sikayetvar' && this.token_editing) {
                    payload.api_token = this.api_token;
                }

                // Update account
                await axios.put(this.accounts_api + this.id, payload)
                  .then((response) => {

                    // Loading stop
                    this.$wait.end('edit');

                    // Show success
                    Vue.toasted.success(this.$t('simple.success_info'));

                    // Close modal
                    this.$close(true);

                  })
                  .catch((error) => {

                    // Loading stop
                    this.$wait.end('edit');

                    if (error.response && error.response.status === 422) {
                      this.token_error = '';
                      this.errorMsg = [];
                      for (const errorKey in error.response.data.errors) {
                        this.errorMsg.push(error.response.data.errors[errorKey][0]);
                      }
                      if (error.response.data.errors?.api_token) {
                        this.token_error = error.response.data.errors.api_token[0];
                      }
                    } else if (error.response && error.response.status === 403) {
                      Vue.toasted.error(this.$t('permission.permission_denied', { permission: 'update-accounts' }));
                    } else {
                      Vue.toasted.error(this.$t('simple.error_info'));
                    }

                  });

            },

            check_confirmation: function() {
                if(this.confirmation){
                    return this.$t('default.enabled');
                } else {
                    return this.$t('default.disabled');
                }
            },

            editToken: function() {
                this.token_editing = true;
                this.api_token = '';
                this.token_error = '';
            },

            validate_edit: async function() {
                this.token_error = '';
                // validate all fields
                await this.$validator.validateAll().then((result) => {
                    if (result) {
                        // Send it to account edit function
                        this.account_edit();
                    }
                });
            },
        },

        computed: {
            // Map getters
            ...mapGetters({
                accounts: 'Accounts/getAccounts',
                user_permissions: 'User/getUserPermissions'
            })
        },
    }
</script>


